module.exports = __webpack_public_path__ + "img/chevronUp.c9641089.svg";